// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3VOXF","buttons":"Footer_buttons__Mer2X"};